import task from "./Component.module.css"


export default function TopSlide()
{
//  let image= new Array("https://www.shine.com/next/static/images/hackathon/Hackathon_2nd_pos_desktop.png",
// "https://www.shine.com/next/static/images/hackathon/Desktop_hackathon.png",
// "https://www.shine.com/_next/image?url=https%3A%2F%2Fstatic1.shine.com%2Fc%2Fs1%2Fimages%2Fcandidate%2Fbanner%2Fwinter_d_home.png&w=640&q=75"

// )
    
    return(
        <div>
                <div className={task.slide}>
                  
                </div>

        </div>
    )
}



{/* //https://www.shine.com/next/static/images/hackathon/Hackathon_2nd_pos_desktop.png// */}
{/* https://www.shine.com/next/static/images/hackathon/Hackathon_2nd_pos_desktop.png
https://www.shine.com/next/static/images/hackathon/Desktop_hackathon.png
https://www.shine.com/_next/image?url=https%3A%2F%2Fstatic1.shine.com%2Fc%2Fs1%2Fimages%2Fcandidate%2Fbanner%2Fwinter_d_home.png&w=640&q=75 */}